var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.name],attrs:{"width":"242px","height":"53px"}},_vm._l((_vm.waves),function(line,index){return _c('polygon',{key:index,attrs:{"points":line,"fill":"currentColor","opacity":Math.random() * (1 - 0.2) + 0.2}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }